var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCircleCheckSolid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 98,
    viewBox: "0 0 110 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2222C0 5.4809 5.4809 0 12.2222 0H42.7778V24.4444C42.7778 27.8247 45.5087 30.5556 48.8889 30.5556H73.3333V37.9271C59.2205 41.9184 48.8889 54.8854 48.8889 70.2778C48.8889 81.5642 54.4462 91.533 62.9635 97.6441C62.3524 97.7396 61.7413 97.7778 61.1111 97.7778H12.2222C5.4809 97.7778 0 92.2969 0 85.5556V12.2222ZM73.3333 24.4444H48.8889V0L73.3333 24.4444ZM55 70.2778C55 62.9843 57.8973 55.9896 63.0546 50.8323C68.2118 45.6751 75.2066 42.7778 82.5 42.7778C89.7935 42.7778 96.7882 45.6751 101.945 50.8323C107.103 55.9896 110 62.9843 110 70.2778C110 77.5712 107.103 84.566 101.945 89.7232C96.7882 94.8805 89.7935 97.7778 82.5 97.7778C75.2066 97.7778 68.2118 94.8805 63.0546 89.7232C57.8973 84.566 55 77.5712 55 70.2778ZM95.3524 62.0087C94.1684 60.8247 92.2205 60.8247 91.0365 62.0087L79.4444 73.6007L73.9635 68.1198C72.7795 66.9358 70.8316 66.9358 69.6476 68.1198C68.4635 69.3038 68.4635 71.2517 69.6476 72.4358L77.2865 80.0747C78.4705 81.2587 80.4184 81.2587 81.6024 80.0747L95.3524 66.3247C96.5365 65.1406 96.5365 63.1927 95.3524 62.0087Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 97.7778,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCircleCheckSolid1);
export default __webpack_public_path__ + "static/media/file-circle-check-solid 1.9dfc7b79d02cdf42c1911c031cbb61ee.svg";
export { ForwardRef as ReactComponent };